import type { ActivityEntry } from '../ActivityChapter.interface';
import Layout from './Layout';
import MainText from './MainText';
import ListItem from './ListItem';
import { useMemo } from 'react';

export default function Intro({ entry, allEntries }: { entry: ActivityEntry, allEntries: Array<ActivityEntry> }) {
    const entries = useMemo(() => {
        const [first, ...rest] = allEntries;
        return rest;
    }, [allEntries]);

    return (
        <Layout
            entry={entry}
            media={entry.media?.[0]}
        >
            <MainText
                offset={.3}
                content={entry.title}
            />

            <div
                style={{
                    position: 'absolute',
                    bottom: '2.6vh', // 50
                    right: '2.6vh', // 50
                    maxWidth: '60vw',
                    maxHeight: '70vh',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '4.17vh', // 80
                }}
            >
                {
                    entries.map((e, idx) => (
                        <ListItem
                            offset={.4}
                            key={idx}
                            title={e.title}
                            details={e.details}
                            size={'small'}
                        />
                    ))
                }
            </div>
        </Layout>
    );
}
